/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import classes from "./SideMenu.module.css";

import { makeStyles } from "@material-ui/core/styles";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import store from "../../Redux Store/store";
//services
import { signOut } from "../../Services/LoginService";
//images
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MonetizationOnSharpIcon from "@mui/icons-material/MonetizationOnSharp";
import HomeIcon from "../Icons/HomeIcon";
import SalesPerformance from "../Icons/SalesPerformance";
import ListIcon from "../Icons/ListIcon";
import Users from "../Icons/Users";
import Support from "../Icons/Support";
import Settings from "../Icons/Settings";
import Logout from "../Icons/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { errorTost } from "../../Services/Toast";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
// mobile menu
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Search from "@mui/icons-material/Search";
import Person from "@mui/icons-material/Person";
// Mobile menu icons
import MenuBackground from "../../Assets/Images/SideMenuIcons/MobileMenuWrap-cropped.svg";
import Dashboard from "../../Assets/Images/SideMenuIcons/MobileMenu/Dashboard.svg";
import DashboardActive from "../../Assets/Images/SideMenuIcons/MobileMenu/Dashboard-active.svg";
import Leads from "../../Assets/Images/SideMenuIcons/MobileMenu/Leads.svg";
import LeadsActive from "../../Assets/Images/SideMenuIcons/MobileMenu/Leads-active.svg";
import Projects from "../../Assets/Images/SideMenuIcons/MobileMenu/Projects.svg";
import ProjectsActive from "../../Assets/Images/SideMenuIcons/MobileMenu/Projects-active.svg";
import Target from "../../Assets/Images/SideMenuIcons/MobileMenu/Target.svg";
import TargetActive from "../../Assets/Images/SideMenuIcons/MobileMenu/Target-active.svg";
import ProfileIcon from "../../Assets/Images/SideMenuIcons/MobileMenu/ProfileIcon-active.svg";
import ProfileIconActive from "../../Assets/Images/SideMenuIcons/MobileMenu/ProfileIcon.svg";
// import LogoIcon from "../../Assets/Images/Logo.png";
import LogoIcon from "../../Assets/Images/VJ LOGO V1 1.svg";
import Fab from "@mui/material/Fab";
import MyTargetIcon from "../Icons/MyTargetIcon";
import Wallet from "../../Assets/Images/SideMenuIcons/MobileMenu/Wallet.svg";
import WalletActive from "../../Assets/Images/SideMenuIcons/MobileMenu/Wallet-active.svg";

import {
  Box,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Menu,
  MenuItem,
} from "@mui/material";

import PersonAddIcon from "@mui/icons-material/PersonAdd";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// ? keyboard to listen when keyboard shows/hides & hide/show mobile menu respectively
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

import AddLead from "../../Modals/AddLead/AddLead";
import FosWallet from "../Icons/FosWallet";

const actions = [
  { icon: <PersonAddIcon />, name: "Add Lead", path: "/Home/AddLead" },
];

const useStyles = makeStyles((theme) => ({
  menu_item: {
    marginBottom: "0.8rem",

    "&:hover": {
      borderRadius: "0.6rem !important",
      background: "#1570ef8f !important",
    },
  },
  icon: {
    minWidth: "1.8rem !important",
    marginRight: "1.5rem",
  },
  menu: {
    margin: "0",
    "& span": {
      display: "inline-block",
      fontFamily: "Inter-Medium",
      fontSize: "1.6rem",
      lineHeight: "2.4rem",
      color: "#D1E9FF",
    },
  },
  active: {
    background: "#1570EF !important",
    color: "#FFFFFF",
    borderRadius: "0.6rem !important",
    "& span": {
      color: "#FFFFFF",
    },
    "&:hover": {
      background: "#1570EF !important",
    },
  },
  user_avatar: {
    display: "inline-block !important",
    marginRight: "1.2rem !important",
    verticalAlign: "middle !important",
    width: "4rem !important",
    height: "4rem !important",
    borderRadius: "100%!important",
    objectFit: "contain",
  },
  speed_dial: {
    "& .MuiSpeedDial-fab": {
      background:
        "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
    },
    "& .MuiSpeedDialIcon-icon": {
      width: "3rem",
      height: "3rem",
    },
    "& .MuiSpeedDialAction-staticTooltipLabel": {
      fontSize: "1.6rem !important",
      lineHeight: "1.6rem !important",
      fontFamily: "Inter-Regular !important",
      wordBreak: "unset !important",
      boxShadow:
        "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
      border: "1px solid #eaecf0 !important",
      background: "#D1E9FF",
      color: "rgb(23, 92, 211)",
    },
    "& .MuiSpeedDialAction-fab": {
      boxShadow:
        "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
    },
    "& .MuiSpeedDialAction-fab > svg": {
      width: "3rem",
      height: "3rem",
      color: "#fff",
    },
  },
  add_lead_menu: {
    background:
      "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
  },
}));

function SideMenu({ props }) {
  const classList = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);
  const [index, setIndex] = useState(0);

  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [fabMenuOpen, setFabMenuOpen] = useState(false);

  const [moreMenuAnchor, setMoreMenuAnchor] = useState(null);

  const isWalletVisible = React.useMemo(() => {
    console.log("Checking wallet visibility:", {
      userType: loggedInUser?.type,
      isWalletVisible: loggedInUser?.isWalletVisible,
      userData: loggedInUser,
    });
    return (
      loggedInUser?.type === "FOS" &&
      loggedInUser?.isWalletVisible === true
    );
  }, [loggedInUser?.type, loggedInUser?.isWalletVisible]);

  const IsAgreementsVisible = React.useMemo(() => {
    console.log("Checking agreement visibility:", {
      userType: loggedInUser?.type,
      IsAgreementsVisible: loggedInUser?.IsAgreementsVisible,
      userData: loggedInUser,
    });
    return (
      loggedInUser?.type === "CP" &&
      loggedInUser?.IsAgreementsVisible === true
    );
  }, [loggedInUser?.type, loggedInUser?.IsAgreementsVisible]);

  const [menuArray, setMenuArray] = useState([
    {
      icon: <HomeIcon color={"#84CAFF"} />,
      activeIcon: <HomeIcon color={"#FFFFFF"} />,
      name: "Dashboard",
      tabName: "home",
      isVisible: true,
      path: "/Home",
    },
    {
      icon: <ListIcon color={"#84CAFF"} />,
      activeIcon: <ListIcon color={"#FFFFFF"} />,
      name: "FoS",
      tabName: "foslist",
      isVisible: true,
      path: "/Home/FosList",
    },
    {
      icon: <Users color={"#84CAFF"} />,
      activeIcon: <Users color={"#FFFFFF"} />,
      name: "Leads",
      tabName: "leads",
      isVisible: true,
      path: "/Home/Leads",
    },
    {
      icon: <ListIcon color={"#84CAFF"} />,
      activeIcon: <ListIcon color={"#FFFFFF"} />,
      name: "Projects",
      tabName: "projects",
      isVisible: true,
      path: "/Home/Projects",
    },
    {
      icon: <FosWallet color={"#84CAFF"} />,
      activeIcon: <FosWallet color={"#FFFFFF"} />,
      name: "Wallet",
      tabName: "foswallet",
      isVisible: true,
      path: "/Home/FosWallet",
    },
    {
      icon: <FosWallet color={"#84CAFF"} />,
      activeIcon: <FosWallet color={"#FFFFFF"} />,
      name: "Agreements",
      tabName: "Agreement",
      isVisible: true,
      path: "/Home/Agreement",
    },
//      {
//   icon: <ListIcon color={"#84CAFF"} />,
//   activeIcon: <ListIcon color={"#FFFFFF"} />,
//   name: "SignOffs",
//   tabName: "cpSignOffs",
//   isVisible: true,
//   path: "/Home/CpSignOffs",  // Correct path for CpSignOffs
// },
    {
      icon: <HomeIcon color={"#84CAFF"} />,
      activeIcon: <HomeIcon color={"#FFFFFF"} />,
      name: "Payout Dashboard",
      tabName: "payoutdashboard",
      isVisible: true,
      path: "/Home/CpPayoutDashBoard",
    },
  ]);

  const [settingsArray, setSettingsArray] = useState([]);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [addLeadModal, setAddLeadModal] = useState(false);

  useEffect(() => {
    console.log("addLeadModal: ", addLeadModal);
    setFabMenuOpen(false);
  }, [addLeadModal, activeMenu]);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener("keyboardWillShow", (e) => {
        console.log("keyboard will show, hiding bottom menu....");
        setKeyboardOpen(true);
      });
      Keyboard.addListener("keyboardDidHide", (e) => {
        console.log("keyboard hidden, showing bottom menu....");
        setTimeout(() => {
          setKeyboardOpen(false);
        }, 100);
      });
    }
    return () => {
      if (Capacitor.isNativePlatform()) {
        Keyboard.removeAllListeners();
      }
    };
  }, []);

  useEffect(() => {
    console.log("Updating menu array with user data:", {
      userType: loggedInUser?.type,
      isWalletVisible: loggedInUser?.isWalletVisible,
      IsAgreementsVisible: loggedInUser?.IsAgreementsVisible,
      fullUserData: loggedInUser,
    });

    const userType = loggedInUser?.type;
    const walletVisible = loggedInUser?.isWalletVisible === true;
    const agreementVisible = loggedInUser?.IsAgreementsVisible === true;

    setMenuArray((prev) =>
      prev.map((item) => {
        if (item.tabName === "foswallet") {
          return {
            ...item,
            isVisible: userType === "FOS" && walletVisible,
          };
        }

        if (item.tabName === "foslist") {
          return {
            ...item,
            isVisible: userType !== "FOS",
          };
        }

        if (item.tabName === "Agreement") {
          return {
            ...item,
            isVisible: userType === "CP" && agreementVisible,
          };
        }

        if (item.tabName === "payoutdashboard") {
          return {
            ...item,
            isVisible: userType === "CP" && loggedInUser?.isAop_Pop_Dashboard_visible === true,
          };
        }

        // if (item.tabName === "cpSignOffs") {
        //   return {
        //     ...item,
        //     isVisible: userType === "CP",
        //   };
        // }

        return item;
      })
    );
  }, [
    loggedInUser?.type,
    loggedInUser?.isWalletVisible,
    loggedInUser?.IsAgreementsVisible,
    loggedInUser?.isAop_Pop_Dashboard_visible,
  ]);

  useEffect(() => {
    console.log("Current menu array:", menuArray);
    console.log("Is agreement visible (computed):", IsAgreementsVisible);
    console.log("User data:", loggedInUser);
  }, [menuArray, IsAgreementsVisible, loggedInUser]);

  function logoutUser() {
    signOut()
      .then(({ err }) => {
        if (err) {
          errorTost(err);
        } else {
          store.dispatch(action.authLogout());
          navigate("/");
        }
      })
      .catch((error) => {
        errorTost(error);
      });
  }

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    window.addEventListener("resize", setVH);
    setVH();
    return () => window.removeEventListener("resize", setVH);
  }, []);

  return (
    <>
      {window.innerWidth > 820 ? (
        <div className={classes.wrapper}>
          <div className={classes.app_info}>
            <div className={classes.app_logo}>
              <img
                src={LogoIcon}
                alt="logo"
                className={classes.sideMenuLogo}
                style={{ marginLeft: "-120px" }}
              />
            </div>
          </div>

          <div className={classes.menu_array}>
            <List>
              {menuArray.map(
                (menu, index) =>
                  menu.isVisible && (
                    <div
                      to={menu.path}
                      key={`MenuArray_${index}`}
                      onKeyDown={(e) => {
                        if (e.keyCode === 32 || e.keyCode === 13) {
                          if (loggedInUser?.type === "FOS") {
                            if (
                              loggedInUser?.cpData?.approvalStatus ===
                              "approved"
                            ) {
                              if (loggedInUser?.approvalStatus === "approved") {
                                navigate(menu.path);
                              }
                            }
                          } else {
                            if (loggedInUser?.approvalStatus === "approved") {
                              navigate(menu.path);
                            }
                          }
                          sessionStorage.clear();
                        }
                      }}
                      onClick={(e) => {
                        console.log("onClick e", e);
                        if (loggedInUser?.type === "FOS") {
                          if (
                            loggedInUser?.cpData?.approvalStatus === "approved"
                          ) {
                            if (loggedInUser?.approvalStatus === "approved") {
                              navigate(menu.path);
                            }
                          }
                        } else {
                          if (loggedInUser?.approvalStatus === "approved") {
                            navigate(menu.path);
                          }
                        }
                        sessionStorage.clear();
                      }}
                    >
                      <ListItem
                        button
                        key={menu.tabName}
                        className={classList.menu_item}
                        selected={activeMenu === menu.tabName.toLowerCase()}
                        classes={{ selected: classList.active }}
                      >
                        <ListItemIcon className={classList.icon}>
                          {activeMenu === menu.tabName.toLowerCase()
                            ? menu.activeIcon
                            : menu.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={menu.name}
                          className={classList.menu}
                        />
                      </ListItem>
                    </div>
                  )
              )}
            </List>
          </div>

          <div className={classes.menu_array} style={{ height: "16%" }}>
            <List>
              {settingsArray.map(
                (menu, index) =>
                  menu.isVisible && (
                    <div
                      to={menu.path}
                      key={`MenuArray_${index}`}
                      onKeyDown={(e) => {
                        if (e.keyCode === 32 || e.keyCode === 13) {
                          navigate(menu.path);
                          sessionStorage.clear();
                        }
                      }}
                      onClick={(e) => {
                        console.log(loggedInUser?.approvalStatus);
                        if (loggedInUser?.approvalStatus === "approved") {
                          navigate(menu.path);
                          sessionStorage.clear();
                        }
                      }}
                    >
                      <ListItem
                        button
                        key={menu.tabName}
                        className={classList.menu_item}
                        selected={activeMenu === menu.tabName.toLowerCase()}
                        classes={{ selected: classList.active }}
                      >
                        <ListItemIcon className={classList.icon}>
                          {activeMenu === menu.tabName.toLowerCase()
                            ? menu.activeIcon
                            : menu.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={menu.name}
                          className={classList.menu}
                        />
                      </ListItem>
                    </div>
                  )
              )}
            </List>
          </div>

          <Divider
            sx={{
              borderColor: "#1570EF",
            }}
          />

          <div className={classes.user_profile}>
            {loggedInUser.profileImgUrl ? (
              <img
                src={
                  process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                  loggedInUser?.profileImgUrl +
                  `?${Date.now()}`
                }
                alt=""
                id="profilePhoto"
                className={classList.user_avatar}
              />
            ) : (
              <AccountCircleOutlinedIcon
                sx={{
                  width: "12%",
                  height: "12%",
                  color: "#FFFFFF",
                  marginRight: "1.2rem",
                }}
              />
            )}

            <div
              className={classes.user_info}
              onClick={(e) => {
                navigate("/Home/Profile");
              }}
            >
              {loggedInUser && (
                <>
                  <div className={classes.user_name} title={loggedInUser.name}>
                    {loggedInUser.name}
                  </div>
                  <div
                    className={classes.user_email}
                    title={loggedInUser?.email}
                  >
                    {loggedInUser?.email}
                  </div>
                </>
              )}
            </div>
            <div
              className={classes.logout}
              tabIndex={0}
              onClick={logoutUser}
              title="Logout"
              onKeyDown={(e) => {
                if (e.keyCode === 32 || e.keyCode === 13) {
                  logoutUser();
                }
              }}
            >
              {<Logout />}
            </div>
          </div>
        </div>
      ) : (
        <Box
          sx={{
            borderRadius: "1.3rem 1.3rem 0 0",
            bgcolor: "#fff",
            boxShadow: "0px 0px 15px rgb(73 83 211 / 5%)",
            height: "10%",
            display: keyboardOpen ? "none" : "",
          }}
        >
          <Tabs
            sx={{
              width: "100%",
              height: "100%",
              boxShadow:
                loggedInUser.type === "CP" && loggedInUser?.cpType === "Entity"
                  ? "0px 0px 15px rgba(73, 83, 211, 0.08)"
                  : "",
              backgroundImage:
                loggedInUser.type === "FOS" ||
                  loggedInUser?.cpType === "Individual"
                  ? `url(${MenuBackground})`
                  : "",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              justifyContent: "end",
            }}
            size="lg"
            aria-label="Bottom Navigation"
            value={index}
            onChange={(event, value) => setIndex(value)}
          >
            <TabList
              variant="plain"
              sx={{ padding: "0", justifyContent: "space-evenly" }}
            >
              <Tab
                orientation="vertical"
                selected={activeMenu === "home"}
                sx={{
                  py: 3,
                  px: 2,
                  color: activeMenu === "home" ? "#28303F" : "#98A2B3",
                  fontWeight: activeMenu === "home" ? 600 : 400,
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  position: "relative",
                  pointerEvents: "none",
                }}
                className={classes.mobile_menu}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (loggedInUser?.type === "FOS") {
                      if (
                        loggedInUser.cpData?.approvalStatus === "approved" &&
                        loggedInUser.approvalStatus === "approved"
                      ) {
                        navigate("/Home");
                      }
                    } else if (loggedInUser?.approvalStatus === "approved") {
                      navigate("/Home");
                    }
                    sessionStorage.clear();
                  }}
                />
                <ListItemDecorator>
                  {activeMenu === "home" ? (
                    <img src={DashboardActive} alt="Dashboard" />
                  ) : (
                    <img src={Dashboard} alt="Dashboard" />
                  )}
                </ListItemDecorator>
                Dashboard
              </Tab>

              <Tab
                orientation="vertical"
                selected={activeMenu === "leads"}
                sx={{
                  py: 3,
                  px: 2,
                  color: activeMenu === "leads" ? "#28303F" : "#98A2B3",
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  position: "relative",
                  pointerEvents: "none",
                }}
                className={classes.mobile_menu}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (loggedInUser?.type === "FOS") {
                      if (
                        loggedInUser.cpData?.approvalStatus === "approved" &&
                        loggedInUser.approvalStatus === "approved"
                      ) {
                        navigate("/home/Leads");
                      }
                    } else if (loggedInUser?.approvalStatus === "approved") {
                      navigate("/home/Leads");
                    }
                    sessionStorage.clear();
                  }}
                />
                <ListItemDecorator>
                  {activeMenu === "leads" ? (
                    <img src={LeadsActive} alt="Leads" />
                  ) : (
                    <img src={Leads} alt="Leads" />
                  )}
                </ListItemDecorator>
                Leads
              </Tab>

              {loggedInUser.type === "FOS" ? (
                <Box
                  orientation="vertical"
                  sx={{
                    background: "transparent !important",
                    color: "#98A2B3",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    bottom: "50%",
                    margin: "0 0 3.5rem",
                    py: 3,
                    px: 2,
                  }}
                  className={classes.mobile_menu}
                  disabled={loggedInUser.approvalStatus !== "approved"}
                >
                  <SpeedDial
                    ariaLabel="Add options"
                    icon={<SpeedDialIcon width="3rem" height="3rem" />}
                    className={classList.speed_dial}
                    onClick={() => setFabMenuOpen((pre) => !pre)}
                    open={fabMenuOpen && !addLeadModal}
                  >
                    {actions.map((action) => (
                      <SpeedDialAction
                        className={classList.add_lead_menu}
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        tooltipOpen
                        onClick={() => {
                          if (loggedInUser?.type === "FOS") {
                            if (
                              loggedInUser.cpData.approvalStatus ===
                              "approved" &&
                              loggedInUser.approvalStatus === "approved"
                            ) {
                              setAddLeadModal(true);
                            }
                          } else if (
                            loggedInUser.approvalStatus === "approved"
                          ) {
                            setAddLeadModal(true);
                          }
                          sessionStorage.clear();
                        }}
                      />
                    ))}
                  </SpeedDial>
                </Box>
              ) : (
                <Tab
                  orientation="vertical"
                  selected={activeMenu === "foslist"}
                  sx={{
                    py: 3,
                    px: 2,
                    color: activeMenu === "foslist" ? "#28303F" : "#98A2B3",
                    backgroundColor: "transparent !important",
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                    },
                    "&:hover": {
                      backgroundColor: "transparent !important",
                    },
                    position: "relative",
                    pointerEvents: "none",
                  }}
                  className={classes.mobile_menu}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 10,
                      cursor: "pointer",
                      pointerEvents: "auto",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (loggedInUser?.approvalStatus === "approved") {
                        navigate("/home/FosList");
                        sessionStorage.clear();
                      }
                    }}
                  />
                  <ListItemDecorator>
                    {activeMenu === "foslist" ? (
                      <img src={LeadsActive} alt="FoS" />
                    ) : (
                      <img src={Leads} alt="FoS" />
                    )}
                  </ListItemDecorator>
                  FoS
                </Tab>
              )}

              <Tab
                orientation="vertical"
                selected={activeMenu === "projects"}
                sx={{
                  py: 3,
                  px: 2,
                  color: activeMenu === "projects" ? "#28303F" : "#98A2B3",
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  position: "relative",
                  pointerEvents: "none",
                }}
                className={classes.mobile_menu}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (loggedInUser?.approvalStatus === "approved") {
                      navigate("/home/Projects");
                      sessionStorage.clear();
                    }
                  }}
                />
                <ListItemDecorator>
                  {activeMenu === "projects" ? (
                    <img src={ProjectsActive} alt="Projects" />
                  ) : (
                    <img src={Projects} alt="Projects" />
                  )}
                </ListItemDecorator>
                Projects
              </Tab>

              <Tab
                orientation="vertical"
                selected={
                  activeMenu === "profile" ||
                  activeMenu === "agreement" ||
                  activeMenu === "foswallet" ||
                  activeMenu === "payoutdashboard"
                }
                sx={{
                  py: 3,
                  px: 2,
                  color:
                    activeMenu === "profile" ||
                      activeMenu === "agreement" ||
                      activeMenu === "foswallet" ||
                      activeMenu === "payoutdashboard"
                      ? "#28303F"
                      : "#98A2B3",
                  backgroundColor: "transparent !important",
                  "&.Mui-selected": {
                    backgroundColor: "transparent !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  position: "relative",
                  pointerEvents: "none",
                }}
                className={classes.mobile_menu}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMoreMenuAnchor(e.currentTarget);
                  }}
                />
                <ListItemDecorator>
                  {activeMenu === "profile" ||
                    activeMenu === "agreement" ||
                    activeMenu === "foswallet" ||
                    activeMenu === "payoutdashboard" ? (
                    <img src={ProfileIcon} alt="More" />
                  ) : (
                    <img src={ProfileIconActive} alt="More" />
                  )}
                </ListItemDecorator>
                More
              </Tab>
            </TabList>
          </Tabs>

          <Menu
            anchorEl={moreMenuAnchor}
            open={Boolean(moreMenuAnchor)}
            onClose={() => setMoreMenuAnchor(null)}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            PaperProps={{
              sx: {
                borderRadius: "12px",
                minWidth: 220,
                mb: 1,
                boxShadow: "0px 8px 24px rgba(16, 24, 40, 0.12)",
                overflow: "hidden",
              },
            }}
          >
            {IsAgreementsVisible && (
              <MenuItem
                onClick={() => {
                  setMoreMenuAnchor(null);
                  if (loggedInUser?.approvalStatus === "approved") {
                    navigate("/home/Agreement");
                    sessionStorage.clear();
                  }
                }}
                sx={{
                  gap: 1.5,
                  py: 1.5,
                  fontSize: "1.45rem",
                  fontFamily: "Inter-Medium",
                }}
              >
                <FosWallet color={"#1570EF"} />
                Agreements
              </MenuItem>
            )}

            {isWalletVisible && (
              <MenuItem
                onClick={() => {
                  setMoreMenuAnchor(null);
                  if (loggedInUser?.approvalStatus === "approved") {
                    navigate("/home/FosWallet");
                    sessionStorage.clear();
                  }
                }}
                sx={{
                  gap: 1.5,
                  py: 1.5,
                  fontSize: "1.45rem",
                  fontFamily: "Inter-Medium",
                }}
              >
                <AccountBalanceWalletOutlinedIcon
                  sx={{ color: "#1570EF", fontSize: "2.2rem" }}
                />
                Wallet
              </MenuItem>
            )}

            {loggedInUser?.type === "CP" && loggedInUser?.isAop_Pop_Dashboard_visible === true && (
              <MenuItem
                onClick={() => {
                  setMoreMenuAnchor(null);
                  if (loggedInUser?.approvalStatus === "approved") {
                    navigate("/Home/CpPayoutDashBoard");
                    sessionStorage.clear();
                  }
                }}
                sx={{
                  gap: 1.5,
                  py: 1.5,
                  fontSize: "1.45rem",
                  fontFamily: "Inter-Medium",
                }}
              >
                <MonetizationOnSharpIcon
                  sx={{ color: "#1570EF", fontSize: "3.2rem" }}
                />
                Payout Dashboard
              </MenuItem>
            )}
{/* 
            {loggedInUser?.type === "CP" && (
              <MenuItem
                onClick={() => {
                  setMoreMenuAnchor(null);
                  if (loggedInUser?.approvalStatus === "approved") {
                    navigate("/Home/CpSignOffs");
                    sessionStorage.clear();
                  }
                }}
                sx={{
                  gap: 1.5,
                  py: 1.5,
                  fontSize: "1.45rem",
                  fontFamily: "Inter-Medium",
                }}
              >
                <ListIcon color={"#1570EF"} />
                SignOffs
              </MenuItem>
            )} */}

            <MenuItem
              onClick={() => {
                setMoreMenuAnchor(null);
                navigate("/Home/Profile");
                sessionStorage.clear();
              }}
              sx={{
                gap: 1.5,
                py: 1.5,
                fontSize: "1.45rem",
                fontFamily: "Inter-Medium",
              }}
            >
              <AccountCircleOutlinedIcon sx={{ color: "#1570EF", fontSize: "3.2rem" }} />
              Profile
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />

            <MenuItem
              onClick={() => {
                setMoreMenuAnchor(null);
                logoutUser();
              }}
              sx={{
                gap: 1.5,
                py: 1.5,
                fontSize: "1.45rem",
                fontFamily: "Inter-Medium",
                color: "#D92D20",
              }}
            >
              <Logout />
              Logout
            </MenuItem>
          </Menu>

          {addLeadModal && (
            <AddLead
              open={addLeadModal}
              handleClose={() => {
                setAddLeadModal(false);
                setFabMenuOpen(false);
              }}
              returnRespButton={() => setFabMenuOpen(false)}
            />
          )}
        </Box>
      )}
    </>
  );
}

export default SideMenu;